
export function getElementDimensions(ref) {
  if (ref && ref.current) {
    const { width, height } = ref.current.getBoundingClientRect();
    return { width, height };
  }
  return { width: 0, height: 0 };
}
export default getElementDimensions;